export default __webpack_public_path__ + "static/media/side-effects-burst.c1a321d7.png";